import React from 'react';
import { Link } from 'react-router-dom';

const ScudAngel = ({ cursorVisibility }) => {
  return (
    <Link id={cursorVisibility} className='scud-angel link none' to='/'>
      <p>scud angel spit purpoil from churchly mother’s functionary</p>
      <p>
        ablution{' '}
        <span className='hidden'>
          {' '}
          ......stil stic to her pubic departure from no wor by
        </span>
      </p>
      <p>still sticks to her pubic departure from no word by</p>
      <p>
        way of mythos at [5:35pm]
        <span className='hidden'>pubic departure from no word by</span>
      </p>
      <p>lemures vanish so as to preserve</p>
      <p>altærs of inhibition—something she termed The Shimmer . that</p>
      <p className='top-margin'>
        her indigible mm could only speak language limited by a thousand little
        lords
      </p>
      <p>
        and feed Wonderbred birds too stale in disbelief to release from her
      </p>
      <p>
        hand pawned skin loned analogies
        <span className='hidden'> sundered half priestly</span>
      </p>
      <p>sundered half priestly</p>
      <p>
        {' '}
        is realization: We could no longer understand her; she gave up
        altogether
      </p>
      <p className='top-margin'>
        the attempt to speak
        <span className='hidden'>
          deferred to desire discovering how paralyzed she was
        </span>
      </p>
      <p>deferred to desire discovering how paralyzed she was</p>
      <p>
        and<span className='hidden'> Her mistake .</span>lie perfectly
        <span className='hidden'>.....</span> still.
        <span className='hidden'>
          {' '}
          ithe use of the presentense e oft e pr esentense...
        </span>
      </p>
      <p className='top-margin'>
        <span className='hidden'> an</span>Her mistake lay–lonely–
        <span className='hidden'>................</span>in the use of the
        presentense
        <span className='hidden'> oft e pr esentense</span>
      </p>
      <p>
        refuse
        <span className='hidden'>..........</span>
        resurrection
        <span className='hidden'>............................</span>
      </p>
    </Link>
  );
};

export default ScudAngel;
